"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));
var _Table = _interopRequireDefault(require("ant-design-vue/es/table/Table"));
var _lodash = _interopRequireDefault(require("lodash.get"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  data: function data() {
    return {
      needTotalList: [],
      selectedRows: [],
      selectedRowKeys: [],
      localLoading: false,
      localDataSource: [],
      localPagination: Object.assign({}, this.pagination)
    };
  },
  props: Object.assign({}, _Table.default.props, {
    rowKey: {
      type: [String, Function],
      default: 'key'
    },
    data: {
      type: Function,
      required: true
    },
    pageNum: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 15
    },
    showSizeChanger: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'default'
    },
    // 展开的图标显示在哪一列
    expandIconColumnIndex: {
      type: Number,
      default: 0
    },
    /**
     * alert: {
     *   show: true,
     *   clear: Function
     * }
     */
    alert: {
      type: [Object, Boolean],
      default: null
    },
    rowSelection: {
      type: Object,
      default: null
    },
    /** @Deprecated */
    showAlertInfo: {
      type: Boolean,
      default: false
    },
    showPagination: {
      type: String | Boolean,
      default: 'auto'
    },
    /**
     * enable page URI mode
     *
     * e.g:
     * /users/1
     * /users/2
     * /users/3?queryParam=test
     * ...
     */
    pageURI: {
      type: Boolean,
      default: false
    }
  }),
  watch: {
    'localPagination.current': function localPaginationCurrent(val) {
      this.pageURI && this.$router.push(_objectSpread(_objectSpread({}, this.$route), {}, {
        name: this.$route.name,
        params: Object.assign({}, this.$route.params, {
          page: val
        })
      }));
    },
    pageNum: function pageNum(val) {
      Object.assign(this.localPagination, {
        current: val
      });
    },
    pageSize: function pageSize(val) {
      Object.assign(this.localPagination, {
        pageSize: val
      });
    },
    showSizeChanger: function showSizeChanger(val) {
      Object.assign(this.localPagination, {
        showSizeChanger: val
      });
    },
    // 同步正在加载中的状态
    loading: function loading(val) {
      this.localLoading = val;
    }
  },
  created: function created() {
    var page = this.$route.params.page;
    var localPageNum = this.pageURI && page && parseInt(page) || this.pageNum;
    this.localPagination = ['auto', true].includes(this.showPagination) && Object.assign({}, this.localPagination, {
      current: localPageNum,
      pageSize: this.pageSize,
      showSizeChanger: this.showSizeChanger
    }) || false;
    // console.log('this.localPagination', this.localPagination)
    this.needTotalList = this.initTotalList(this.columns);
    this.loadData();
  },
  methods: {
    /**
     * 表格重新加载方法
     * 如果参数为 true, 则强制刷新到第一页
     * @param Boolean bool
     */
    refresh: function refresh() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      bool && (this.localPagination = Object.assign({}, {
        current: 1,
        pageSize: this.pageSize
      }));
      this.loadData();
    },
    /**
     * 加载数据方法
     * @param {Object} pagination 分页选项器
     * @param {Object} filters 过滤条件
     * @param {Object} sorter 排序条件
     */
    loadData: function loadData(pagination, filters, sorter) {
      var _this = this;
      this.localLoading = true;
      var params = Object.assign({
        page: pagination && pagination.current || this.showPagination && this.localPagination.current || this.pageNum
        // pageSize: (pagination && pagination.pageSize) ||
        //   this.showPagination && this.localPagination.pageSize || this.pageSize
      }, sorter && sorter.field && {
        sortField: sorter.field
      } || {}, sorter && sorter.order && {
        sortOrder: sorter.order
      } || {}, _objectSpread({}, filters));
      // console.log('params', params)
      var result = this.data(params);
      // 对接自己的通用数据接口需要修改下方代码中的 r.page, r.totalCount, r.data
      // eslint-disable-next-line
      if ((_typeof(result) === 'object' || typeof result === 'function') && typeof result.then === 'function') {
        result.then(function (r) {
          _this.localPagination = _this.showPagination && Object.assign({}, _this.localPagination, {
            current: r.current_page,
            // 返回结果中的当前分页数
            total: r.total,
            // 返回结果中的总记录数
            showSizeChanger: _this.showSizeChanger,
            pageSize: pagination && pagination.pageSize || _this.localPagination.pageSize
          }) || false;
          // 为防止删除数据后导致页面当前页面数据长度为 0 ,自动翻页到上一页
          if (r.data.length === 0 && _this.showPagination && _this.localPagination.current > 1) {
            _this.localPagination.current--;
            _this.loadData();
            return;
          }

          // 这里用于判断接口是否有返回 r.totalCount 且 this.showPagination = true 且 page 和 pageSize 存在 且 totalCount 小于等于 page * pageSize 的大小
          // 当情况满足时，表示数据不满足分页大小，关闭 table 分页功能
          try {
            if (['auto', true].includes(_this.showPagination) && r.total <= r.current_page * _this.localPagination.pageSize) {
              _this.localPagination.hideOnSinglePage = true;
            }
          } catch (e) {
            _this.localPagination = false;
          }
          // console.log('loadData -> this.localPagination', this.localPagination)
          _this.localDataSource = r.data; // 返回结果中的数组数据
          _this.localLoading = false;
        });
      }
    },
    initTotalList: function initTotalList(columns) {
      var totalList = [];
      columns && columns instanceof Array && columns.forEach(function (column) {
        if (column.needTotal) {
          totalList.push(_objectSpread(_objectSpread({}, column), {}, {
            total: 0
          }));
        }
      });
      return totalList;
    },
    /**
     * 用于更新已选中的列表数据 total 统计
     * @param selectedRowKeys
     * @param selectedRows
     */
    updateSelect: function updateSelect(selectedRowKeys, selectedRows) {
      this.selectedRows = selectedRows;
      this.selectedRowKeys = selectedRowKeys;
      var list = this.needTotalList;
      this.needTotalList = list.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          total: selectedRows.reduce(function (sum, val) {
            var total = sum + parseInt((0, _lodash.default)(val, item.dataIndex));
            return isNaN(total) ? 0 : total;
          }, 0)
        });
      });
    },
    /**
     * 清空 table 已选中项
     */
    clearSelected: function clearSelected() {
      if (this.rowSelection) {
        this.rowSelection.onChange([], []);
        this.updateSelect([], []);
      }
    },
    /**
     * 处理交给 table 使用者去处理 clear 事件时，内部选中统计同时调用
     * @param callback
     * @returns {*}
     */
    renderClear: function renderClear(callback) {
      var _this2 = this;
      var h = this.$createElement;
      if (this.selectedRowKeys.length <= 0) return null;
      return h("a", {
        "style": "margin-left: 24px",
        "on": {
          "click": function click() {
            callback();
            _this2.clearSelected();
          }
        }
      }, ["\u6E05\u7A7A"]);
    },
    renderAlert: function renderAlert() {
      var h = this.$createElement;
      // 绘制统计列数据
      var needTotalItems = this.needTotalList.map(function (item) {
        return h("span", {
          "style": "margin-right: 12px"
        }, [item.title, "\u603B\u8BA1 ", h("a", {
          "style": "font-weight: 600"
        }, [!item.customRender ? item.total : item.customRender(item.total)])]);
      });

      // 绘制 清空 按钮
      var clearItem = typeof this.alert.clear === 'boolean' && this.alert.clear ? this.renderClear(this.clearSelected) : this.alert !== null && typeof this.alert.clear === 'function' ? this.renderClear(this.alert.clear) : null;

      // 绘制 alert 组件
      return h("a-alert", {
        "attrs": {
          "showIcon": true
        },
        "style": "margin-bottom: 16px"
      }, [h("template", {
        "slot": "message"
      }, [h("span", {
        "style": "margin-right: 12px"
      }, ["\u5DF2\u9009\u62E9: ", h("a", {
        "style": "font-weight: 600"
      }, [this.selectedRows.length])]), needTotalItems, clearItem])]);
    }
  },
  render: function render() {
    var _this3 = this;
    var h = arguments[0];
    var props = {};
    var localKeys = Object.keys(this.$data);
    var showAlert = _typeof(this.alert) === 'object' && this.alert !== null && this.alert.show && typeof this.rowSelection.selectedRowKeys !== 'undefined' || this.alert;
    Object.keys(_Table.default.props).forEach(function (k) {
      var localKey = "local".concat(k.substring(0, 1).toUpperCase()).concat(k.substring(1));
      if (localKeys.includes(localKey)) {
        props[k] = _this3[localKey];
        return props[k];
      }
      if (k === 'rowSelection') {
        if (showAlert && _this3.rowSelection) {
          // 如果需要使用alert，则重新绑定 rowSelection 事件
          // console.log('this.rowSelection', this.rowSelection)
          props[k] = _objectSpread(_objectSpread({}, _this3.rowSelection), {}, {
            selectedRows: _this3.selectedRows,
            selectedRowKeys: _this3.selectedRowKeys,
            onChange: function onChange(selectedRowKeys, selectedRows) {
              _this3.updateSelect(selectedRowKeys, selectedRows);
              typeof _this3[k].onChange !== 'undefined' && _this3[k].onChange(selectedRowKeys, selectedRows);
            }
          });
          return props[k];
        } else if (!_this3.rowSelection) {
          // 如果没打算开启 rowSelection 则清空默认的选择项
          props[k] = null;
          return props[k];
        }
      }
      _this3[k] && (props[k] = _this3[k]);
      return props[k];
    });
    var table = h("a-table", (0, _babelHelperVueJsxMergeProps.default)([{}, {
      props: props,
      scopedSlots: _objectSpread({}, this.$scopedSlots)
    }, {
      "on": {
        "change": this.loadData,
        "expand": function expand(expanded, record) {
          _this3.$emit('expand', expanded, record);
        }
      }
    }]), [Object.keys(this.$slots).map(function (name) {
      return h("template", {
        "slot": name
      }, [_this3.$slots[name]]);
    })]);
    return h("div", {
      "class": "table-wrapper"
    }, [showAlert ? this.renderAlert() : null, table]);
  }
};